import SectionGridGalery from "../sections/galeria/grid-galery/SectionGridGalery";
import SectionMagazine from "../sections/galeria/section-magazine/SectionMagazine";
const Galeria = () => {
  return (
    <>
      <SectionGridGalery />
      <SectionMagazine />
    </>
  );
};

export default Galeria;
